module.exports = __webpack_public_path__ + "static/media/28-6.972fb3cd.mp3";